/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useUpdateEventDayUserMutation } from '../api/eventUser.api'
import { useCreateUserMutation } from '../api/user.api'
import FormBuilder from '../components/FormBuilder'
import { useMyContext } from '../context/context'
import useHistoryCustom from '../hooks/useHistoryCustom'
import useSettingsV2 from '../hooks/useSettingsV2'

const uuid = uuidv4()

const CreateAnonymous = () => {
  const history = useHistoryCustom()
  const { event, user: currentUser, myContext } = useMyContext()
  const { settings } = useSettingsV2()

  const [createUser] = useCreateUserMutation()
  const [updateEventDay] = useUpdateEventDayUserMutation()

  const init = useCallback(async () => {
    if (settings && event) {
      if (!settings.FO_MEETING_ANONYMOUS_IS_ACTIVE) {
        history.push('')
      } else if (!currentUser) {
        const user = await createUser({
          ...myContext,
          user: { firstName: ' ', lastName: ' ', email: `${uuid}@gayakoa.com`, isExhibitor: settings?.FO_MEETING_IS_EXHIBITOR_DEFAULT },
        }).unwrap()
        localStorage.setItem('token', user.token)
        window.location.reload()

        // const promises = [
        //   ...event.days.map(ed => {
        //     return updateEventDay({
        //       ...myContext,
        //       userId: user.id,
        //       dayId: ed.id,
        //       day: { registered: true, registeredAt: new Date() },
        //     }).unwrap()
        //   }),
        // ]
        // await Promise.all(promises)

        // await login(user.token)
      }
      // else if (currentUser && !settings.FO_MEETING_ANONYMOUS_FORM_ID) {
      //   history.push(settings.FO_MEETING_SCAN_BADGE_REFERER || '')
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings, event])

  const updateUser = useCallback(async () => {
    if (currentUser && event && myContext && settings) {
      const promises = [
        ...event.days.map(ed => {
          return updateEventDay({
            ...myContext,
            dayId: ed.id,
            day: { registered: true, registeredAt: new Date() },
          }).unwrap()
        }),
      ]
      await Promise.all(promises)

      if (!settings.FO_MEETING_ANONYMOUS_FORM_ID || !settings?.FO_MEETING_CREATE_ANONYMOUS_FORM_ID) {
        history.push(settings.FO_MEETING_SCAN_BADGE_REFERER || '')
      }
    }
  }, [currentUser, event, myContext, settings])

  useEffect(() => {
    updateUser()
  }, [updateUser])

  useEffect(() => {
    init()
  }, [init])

  return (
    <div>
      {currentUser && (
        <FormBuilder
          formIdDefault={settings?.FO_MEETING_CREATE_ANONYMOUS_FORM_ID}
          userId={currentUser.id}
          onFinish={() => history.push(settings.FO_MEETING_SCAN_BADGE_REFERER || '')}
        />
      )}
    </div>
  )
}

export default CreateAnonymous
